module.exports = __webpack_public_path__ + "img/mkgest.f93c8f54.jpg";